"use strict";
/** All objects which are schema-versioned. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaVersions = exports.isKonfektionierungNext = exports.konfektionierungNextUseableDef = exports.isKonfektionierungLatest = exports.konfektionierungLatestUseableDef = exports.isMontageSetNext = exports.montageSetNextUseableDef = exports.isMontageSetLatest = exports.montageSetLatestUseableDef = exports.isVerpackungNext = exports.verpackungNextUseableDef = exports.isVerpackungLatest = exports.verpackungLatestUseableDef = exports.isLinkNext = exports.linkNextUseableDef = exports.isLinkLatest = exports.linkLatestUseableDef = exports.isKetteNext = exports.ketteNextUseableDef = exports.isKetteLatest = exports.ketteLatestUseableDef = exports.isAeNext = exports.aeNextUseableDef = exports.isAeLatest = exports.aeLatestUseableDef = exports.isIANext = exports.iANextUseableDef = exports.isIALatest = exports.iALatestUseableDef = void 0;
const Link1_1 = require("./link/versions/Link1");
const Kette24_1 = require("./kette/versions/Kette24");
const Ae10_1 = require("./ae/versions/Ae10");
const Verpackung18_1 = require("./verpackung/versions/Verpackung18");
const MontageSet9_1 = require("./montageSet/versions/MontageSet9");
const Konfektionierung10_1 = require("./konfektionierung/versions/Konfektionierung10");
const IA15_1 = require("./ia/versions/IA15");
const notUsed = {
    latest: '',
    next: '',
};
// -----------------------------------------
// articles having same schema for all apps
const espool = { latest: '5', next: '5' };
const ketteSerie = {
    latest: '11',
    next: '11',
};
const ia = {
    latest: '15',
    next: '15',
};
exports.iALatestUseableDef = IA15_1.iA15UseableDef;
exports.isIALatest = IA15_1.isIA15;
exports.iANextUseableDef = IA15_1.iA15UseableDef;
exports.isIANext = IA15_1.isIA15;
const ae = { latest: '10', next: '10' };
exports.aeLatestUseableDef = Ae10_1.ae10UseableDef;
exports.isAeLatest = Ae10_1.isAe10;
exports.aeNextUseableDef = Ae10_1.ae10UseableDef;
exports.isAeNext = Ae10_1.isAe10;
const kette = { latest: '24', next: '24' };
exports.ketteLatestUseableDef = Kette24_1.kette24UseableDef;
exports.isKetteLatest = Kette24_1.isKette24;
exports.ketteNextUseableDef = Kette24_1.kette24UseableDef;
exports.isKetteNext = Kette24_1.isKette24;
const link = { latest: '1', next: '1' };
exports.linkLatestUseableDef = Link1_1.link1UseableDef;
exports.isLinkLatest = Link1_1.isLink1;
exports.linkNextUseableDef = Link1_1.link1UseableDef;
exports.isLinkNext = Link1_1.isLink1;
const verpackung = { latest: '18', next: '18' };
exports.verpackungLatestUseableDef = Verpackung18_1.verpackung18UseableDef;
exports.isVerpackungLatest = Verpackung18_1.isVerpackung18;
exports.verpackungNextUseableDef = Verpackung18_1.verpackung18UseableDef;
exports.isVerpackungNext = Verpackung18_1.isVerpackung18;
const montageSet = { latest: '9', next: '9' };
exports.montageSetLatestUseableDef = MontageSet9_1.montageSet9UseableDef;
exports.isMontageSetLatest = MontageSet9_1.isMontageSet9;
exports.montageSetNextUseableDef = MontageSet9_1.montageSet9UseableDef;
exports.isMontageSetNext = MontageSet9_1.isMontageSet9;
const leitungSerie = {
    latest: '9',
    next: '9',
};
const konfektionierung = {
    latest: '10',
    next: '10',
};
exports.konfektionierungLatestUseableDef = Konfektionierung10_1.konfektionierung10UseableDef;
exports.isKonfektionierungLatest = Konfektionierung10_1.isKonfektionierung10;
exports.konfektionierungNextUseableDef = Konfektionierung10_1.konfektionierung10UseableDef;
exports.isKonfektionierungNext = Konfektionierung10_1.isKonfektionierung10;
// -----------------------------------------
// EIQ specific
const EIQ = {
    articles: {
        ae,
        espool,
        fuehrungsrinne: {
            latest: '10',
            next: '10',
        },
        ia,
        kette,
        konfektionierung,
        leitung: {
            latest: '13',
            next: '13',
        },
        link,
        montageSet,
        montBes: notUsed,
        zubehoer: notUsed,
        verpackung,
        zugentlastung: {
            latest: '10',
            next: '10',
        },
    },
    aeZubehoerRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    befestigungInnenCProfil: notUsed,
    belastungGleitend: notUsed,
    fl: notUsed,
    discounts: {
        latest: '9',
        next: '9',
    },
    discountCriteria: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    discountRule: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    iaKetteSerieRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    iaRefItem: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    kettenSerienSystem: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    langTextArray: notUsed,
    minBauraumRinneRef: notUsed,
    rinnenVariante: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    staticIAArtikelRef: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    zugentlastungMontage: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    zusBreiteFRBefestigung: notUsed,
};
// -----------------------------------------
// EKE specific (also ECF and EIC)
const EKE = {
    articles: {
        ae,
        espool,
        fuehrungsrinne: {
            latest: '10',
            next: '10',
        },
        ia,
        kette,
        konfektionierung,
        leitung: {
            latest: '13',
            next: '13',
        },
        link,
        montageSet,
        montBes: notUsed,
        zubehoer: notUsed,
        verpackung,
        zugentlastung: {
            latest: '9',
            next: '9',
        },
    },
    aeZubehoerRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    befestigungInnenCProfil: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    belastungGleitend: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    discounts: notUsed,
    discountCriteria: notUsed,
    discountRule: notUsed,
    fl: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    iaKetteSerieRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    iaRefItem: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    kettenSerienSystem: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    langTextArray: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    minBauraumRinneRef: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    rinnenVariante: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    staticIAArtikelRef: {
        latest: '1.0.0',
        next: '1.0.0',
    },
    zugentlastungMontage: {
        latest: '0.1.0',
        next: '0.1.0',
    },
    zusBreiteFRBefestigung: {
        latest: '1.0.0',
        next: '1.0.0',
    },
};
exports.schemaVersions = {
    apps: {
        EIQ,
        EKE,
        EIC: EKE,
        ECF: EKE,
        TEST: EKE,
    },
    common: {
        articles: {
            espool,
            ia,
            kette,
            konfektionierung,
            link,
            verpackung,
            // TODO use same schemaversion
            ae: notUsed,
            leitung: notUsed,
            zubehoer: notUsed,
            fuehrungsrinne: notUsed,
            montageSet: notUsed,
            montBes: notUsed,
            zugentlastung: notUsed,
        },
        articleSeries: {
            ketteSerie,
            leitungSerie,
        },
        articleRef: {
            latest: '0.3.0',
            next: '0.3.0',
        },
        countryPrice: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        countryPriceCountry: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        countryPriceCurrency: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        countryText: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        langText: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        ketteSerieCompact: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        ketteSerieGrease: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        rolEchainParts: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        manufacturerArtNr: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        unitNumber: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        espoolLinear: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        espoolTwisterband: {
            latest: '0.2.0',
            next: '0.2.0',
        },
        fileDataRecord: {
            latest: '0.1.1',
            next: '0.1.1',
        },
        ketteSerieRef: {
            latest: '0.1.0',
            next: '0.1.0',
        },
        iaRefItem: {
            latest: '0.1.0',
            next: '0.1.0',
        },
    },
};
//# sourceMappingURL=schemaVersions.js.map